import { PortfolioViewMode, SecurityColumnVisibility } from '../../features/clients/client/portfolio/overview/store/types';

export interface UserSettingsState {
  dataFeeds: DataFeed[];
  isDataFromTriumph: boolean;
  rebalanceFromTriumph: boolean;
  preferences: Record<string, unknown>;
  loadedPreferencePaths: string[];
}

export interface DataFeed {
  adviserId: number;
  vendor: string;
  isRegistered: boolean;
}

export const UserPreferencePath = {
  ClientsPortfolio: 'clients.portfolio',
} as const;

export type UserPreferencePathKey = typeof UserPreferencePath[keyof typeof UserPreferencePath];

export interface VersionedPreferences {
  version: number;
}

export interface PreferenceUpgrader<T extends VersionedPreferences> {
  latestVersion: number;
  steps: Record<number, (old: T) => T>;
}

export interface PortfolioPreferences extends VersionedPreferences {
  defaultView?: PortfolioViewMode;
  defaultColumns?: SecurityColumnVisibility;
}

export type UserPreferenceMap = {
  [UserPreferencePath.ClientsPortfolio]: PortfolioPreferences;
};

export interface UserPreferencesDto<TPreferences = unknown> {
  entityId: number;
  path: string;
  preferences: TPreferences | null;
}

export interface FetchUserPreferencesPayload {
  path: string;
}

export interface SaveUserPreferencesPayload<TPreferences = unknown> {
  entityId: number;
  path: string;
  preferences: TPreferences;
}
